import React, { useEffect, useRef } from 'react';
import { FaMobileAlt, FaGlobe, FaTelegram } from 'react-icons/fa';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import "./Services.css";

const Services = () => {
  gsap.registerPlugin(ScrollTrigger);
  const container = useRef(null);

  useEffect(() => {
    const el = container.current;
    gsap.fromTo('.section__header',
      { opacity: 0 },
      {
        opacity: 1,
        scrollTrigger: { trigger: el }
      });

    gsap.fromTo('.service',
      { y: -50, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        scrollTrigger: {
          trigger: el,
          start: "-100% bottom",
          end: "bottom 20%",
          scrub: true,
        }
      });
  }, []);

  return (
    <section ref={container} id='services'>
      <div className="section__wrapper services__container">
        <div className="section__header center">
          <h2 className='primary__title'>Services</h2>
          <h3 className="text__muted description">
            What I can build for you
          </h3>
        </div>
        <div className="services__group">

          <article className="service" style={{ "--color-primary": '#8750f7' }}>
            <div className="service__top">
              <div className="icon__container">
                <FaMobileAlt className='icon' />
              </div>
              <h3 className='title'>Mobile App Development</h3>
            </div>
            <div className="service__middle">
              <p className="text__muted description">
                I design and develop Android applications published on the Google Play Store. From network utility tools like NetDroid to privacy-focused apps like Temp Mail and PDF Unlocker — I build performant, user-friendly mobile experiences.
              </p>
            </div>
            <div className="service__bottom">
              <a href="https://play.google.com/store/apps/developer?id=Ragnar+Servers" target="_blank" rel="noreferrer" className='btn btn__primary'>View on Play Store</a>
            </div>
          </article>

          <article className="service" style={{ "--color-primary": '#33c648' }}>
            <div className="service__top">
              <div className="icon__container">
                <FaGlobe className='icon' />
              </div>
              <h3 className='title'>Web Development</h3>
            </div>
            <div className="service__middle">
              <p className="text__muted description">
                I build full-stack web applications and services. TempMailGet is a free disposable email platform I created, serving thousands of users with instant temporary email generation, multiple domain support, and a mobile-friendly interface.
              </p>
            </div>
            <div className="service__bottom">
              <a href="https://tempmailget.com/" target="_blank" rel="noreferrer" className='btn btn__primary'>Visit TempMailGet</a>
            </div>
          </article>

          <article className="service" style={{ "--color-primary": '#2AABEE' }}>
            <div className="service__top">
              <div className="icon__container">
                <FaTelegram className='icon' />
              </div>
              <h3 className='title'>Telegram Communities & Bots</h3>
            </div>
            <div className="service__middle">
              <p className="text__muted description">
                I build and manage Telegram communities and automated bots. Ragnar Servers is a thriving tech community where I share configuration files, premium giveaways, and tech resources with a growing audience of enthusiasts.
              </p>
            </div>
            <div className="service__bottom">
              <a href="https://t.me/ragnarservers" target="_blank" rel="noreferrer" className='btn btn__primary'>Join Channel</a>
            </div>
          </article>

        </div>
      </div>
    </section>
  );
};

export default Services;
